import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/navbar.css";
import { isGoogleAccount } from "../utils/googleAuth";
import siteLogo from "../images/new_logo.png"; // ← add your logo image here

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isGoogleLogin, setIsGoogleLogin] = useState(false);
  const [userItem, setUserItem] = useState(null);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const hoverTimer = useRef(null);

  const openUserMenu = () => {
    if (hoverTimer.current) clearTimeout(hoverTimer.current);
    setDropdownOpen(true);
  };
  const closeUserMenuDelayed = () => {
    if (hoverTimer.current) clearTimeout(hoverTimer.current);
    hoverTimer.current = setTimeout(() => setDropdownOpen(false), 220);
  };

  useEffect(() => {
    return () => {
      if (hoverTimer.current) clearTimeout(hoverTimer.current);
    };
  }, []);

  useEffect(() => {
    try {
      const itemStr = localStorage.getItem("isLogin");
const parsed = itemStr ? JSON.parse(itemStr) : null;

if (parsed?.authProvider === "Google") {
    setIsGoogleLogin(true);
} else {
    setIsGoogleLogin(false);
}
      if (parsed && parsed.expiry && parsed.expiry > Date.now()) {
        setIsLogin(true);
        setUserItem(parsed);
      } else {
        setIsLogin(false);
        setUserItem(null);
      }
    } catch {
      setIsLogin(false);
      setUserItem(null);
    }
  }, []);

  useEffect(() => {
    function handleDocClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("click", handleDocClick);
    return () => document.removeEventListener("click", handleDocClick);
  }, []);

  function handleLogout(e) {
    e.preventDefault();
    localStorage.removeItem("isLogin");
    setIsLogin(false);
    setUserItem(null);
    navigate("/");
    window.location.reload(false);
  }

  function truncatedName(name) {
    if (!name) return "";
    return name.length > 14 ? name.substring(0, 14) + "…" : name;
  }

  function toggleMenu() {
    setMenuOpen((s) => !s);
    if (!menuOpen) setDropdownOpen(false);
  }

  const isGoogleUser = isGoogleAccount(userItem);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* LOGO aligned left */}
        <Link
          to="/"
          className="navbar-logo"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            marginRight: "auto",
          }}
        >
          <img
    src={siteLogo}
    alt="PolyQuizz Logo"
    className="navbar-logo-img"
/>
          <span className="logo-blue">Poly</span>
          <span className="logo-purple">Quizz</span>
        </Link>

        {/* Hamburger (mobile) */}
        <div className="menu-icon" onClick={toggleMenu} aria-label="Toggle menu" role="button">
          <div className={`bar ${menuOpen ? "open" : ""}`} />
          <div className={`bar ${menuOpen ? "open" : ""}`} />
          <div className={`bar ${menuOpen ? "open" : ""}`} />
        </div>

        {/* Links */}
        <div className={`navbar-links ${menuOpen ? "active" : ""}`}>
          <Link to="/" onClick={() => setMenuOpen(false)} className="nav-link">
            Home
          </Link>
          <Link to="/all-exam-prep-practice-test" onClick={() => setMenuOpen(false)} className="nav-link">
            Exams
          </Link>
          {isLogin && (
            <Link to="/check-user-progress" onClick={() => setMenuOpen(false)} className="nav-link">
              Dashboard
            </Link>
          )}

          {/* Auth area */}
          {isLogin && userItem ? (
            <div
              className="user-block user-hoverable"
              ref={dropdownRef}
              onMouseEnter={openUserMenu}
              onMouseLeave={closeUserMenuDelayed}
              style={{ position: "relative", display: "flex", alignItems: "center", gap: 8 }}
            >
              <button
                className="user-pill"
                onClick={(e) => {
                  e.preventDefault();
                  openUserMenu();
                }}
                aria-haspopup="menu"
                aria-expanded={dropdownOpen}
              >
                <span className="user-avatar">
                  {(userItem?.username || userItem?.user || userItem?.email || "U")
                    .charAt(0)
                    .toUpperCase()}
                </span>
                <span className="user-name">
                  {truncatedName(userItem.username || userItem.user || userItem.email || "")}
                </span>
                <svg
                  className={`user-caret ${dropdownOpen ? "open" : ""}`}
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                >
                  <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>

              {dropdownOpen && (
                <div
                  className="user-dropdown modern"
                  role="menu"
                  onMouseEnter={openUserMenu}
                  onMouseLeave={closeUserMenuDelayed}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "calc(100% + 6px)",
                    background: "#fff",
                    borderRadius: 12,
                    boxShadow: "0 18px 46px rgba(16,24,40,0.16)",
                    minWidth: 220,
                    zIndex: 2000,
                    padding: "8px 0",
                    border: "1px solid rgba(0,0,0,0.06)",
                  }}
                >
                  <Link
                    to="/check-user-progress"
                    onClick={() => {
                      setDropdownOpen(false);
                      setMenuOpen(false);
                    }}
                    className="user-dropdown-item"
                    role="menuitem"
                  >
                    <span className="ud-icon">
                      <svg viewBox="0 0 24 24" width="16" height="16">
                        <path d="M3 3h4v18H3zM10 13h4v8h-4zM17 8h4v13h-4z" fill="currentColor" />
                      </svg>
                    </span>
                    My Progress
                  </Link>


                 {!isGoogleLogin && (
    <Link
        to="/auth/change-user-password"
        onClick={() => {
            setDropdownOpen(false);
            setMenuOpen(false);
        }}
        className="user-dropdown-item"
        role="menuitem"
    >
        <span className="ud-icon">
            <svg viewBox="0 0 24 24" width="16" height="16">
                <path
                    d="M7 11V7a5 5 0 0110 0v4h1a2 2 0 012 2v7H4v-7a2 2 0 012-2h1zm2 0h6V7a3 3 0 10-6 0v4z"
                    fill="currentColor"
                />
            </svg>
        </span>
        Change Password
    </Link>
)}

                  <button
                    onClick={handleLogout}
                    className="user-dropdown-item danger"
                    role="menuitem"
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    <span className="ud-icon">
                      <svg viewBox="0 0 24 24" width="16" height="16">
                        <path
                          d="M16 17l5-5-5-5v3H9v4h7v3zM4 4h8V2H4a2 2 0 00-2 2v16a2 2 0 002 2h8v-2H4V4z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <Link to="/login" onClick={() => setMenuOpen(false)}>
                <button className="btn-signin">Sign In</button>
              </Link>
              <Link to="/register" onClick={() => setMenuOpen(false)}>
                <button className="btn-signup">Sign Up</button>
              </Link>
            </>
          )}

          {menuOpen && isLogin && userItem && (
            <div style={{ width: "100%", marginTop: 8 }}>
              <Link to="/check-user-progress" onClick={() => setMenuOpen(false)} style={{ display: "block", padding: "8px 0" }}>
                My Progress
              </Link>
              
            
             {!isGoogleLogin && (
    <Link
        to="/auth/change-user-password"
        onClick={() => setMenuOpen(false)}
        style={{ display: "block", padding: "8px 0" }}
    >
        Change Password
    </Link>
)}

              <button
                onClick={handleLogout}
                className="user-dropdown-item danger"
                role="menuitem"
              >
                <span className="ud-icon">
                  <svg viewBox="0 0 24 24" width="16" height="16">
                    <path
                      d="M16 17l5-5-5-5v3H9v4h7v3zM4 4h8V2H4a2 2 0 00-2 2v16a2 2 0 002 2h8v-2H4V4z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
